"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSCRIPTION_DEFAULT_TTL = exports.SUBSCRIPTION_EVENTS = void 0;
const time_1 = require("./time");
exports.SUBSCRIPTION_EVENTS = {
    payload: "subscription_payload",
    created: "subscription_created",
    updated: "subscription_updated",
    deleted: "subscription_deleted",
};
exports.SUBSCRIPTION_DEFAULT_TTL = time_1.THREE_WEEKS;
//# sourceMappingURL=subscription.js.map